module.exports = __webpack_public_path__ + "static/media/cq_ultima_settimana b.8c5eaca1.svg";